import React, { useState, useEffect } from 'react';
import { FiEdit2, FiTrash2, FiPlus, FiSave, FiX, FiUsers, FiCheck } from 'react-icons/fi';
import ImageUploadField from './ImageUploadField';
import './AdminManage.css';

const STORAGE_KEY = 'iamar_experts_data';

const DEFAULT_EXPERTS = [
  { id: 1, name: "Dr. Redouane EL MAJDOULI", title: "Expert en Cyber-Intelligence", countryCode: "ma", country: "Maroc", company: "IAMAR Institute", company_logo: "", domain: "Sécurité", image: "" },
  { id: 2, name: "Prof. Jean-Marc Dupont", title: "Spécialiste en Géopolitique", countryCode: "fr", country: "France", company: "Sorbonne University", company_logo: "", domain: "Géopolitique", image: "" },
  { id: 3, name: "Dr. Sarah Al-Mansoor", title: "AI Ethics Specialist", countryCode: "gb", country: "United Kingdom", company: "Oxford Research", company_logo: "", domain: "AI Ethics", image: "" },
  { id: 4, name: "Carlos Mendoza", title: "Critical Infrastructure Security", countryCode: "es", country: "Espagne", company: "TechDefensa", company_logo: "", domain: "Infrastructures", image: "" }
];

export default function AdminExperts() {
  const [experts, setExperts] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    title: '',
    country: 'Maroc',
    countryCode: 'ma',
    company: '',
    company_logo: '',
    domain: '',
    image: '',
    bio: ''
  });

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        setExperts(JSON.parse(saved));
      } else {
        setExperts(DEFAULT_EXPERTS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_EXPERTS));
      }
    } catch (e) {
      console.error(e);
      setExperts(DEFAULT_EXPERTS);
    }
  }, []);

  const saveExpertsList = (updated) => {
    setExperts(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    setSaveSuccess(true);
    setTimeout(() => setSaveSuccess(false), 2500);
  };

  const handleEdit = (expert) => {
    setFormData(expert);
    setEditingId(expert.id);
    setIsFormOpen(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Voulez-vous vraiment supprimer cet expert ?')) {
      const updated = experts.filter(e => e.id !== id);
      saveExpertsList(updated);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name) return;

    let updated;
    if (editingId) {
      updated = experts.map(exp => exp.id === editingId ? { ...formData, id: editingId } : exp);
    } else {
      const newExpert = { ...formData, id: Date.now() };
      updated = [newExpert, ...experts];
    }
    saveExpertsList(updated);
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      name: '',
      title: '',
      country: 'Maroc',
      countryCode: 'ma',
      company: '',
      company_logo: '',
      domain: '',
      image: '',
      bio: ''
    });
    setEditingId(null);
    setIsFormOpen(false);
  };

  return (
    <div className="admin-manage-card" style={{ background: '#ffffff', borderRadius: 8, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: 16, marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '1.4rem', color: '#1b1e4f', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 10 }}>
            <FiUsers /> Gestion des Experts & Consultants
          </h2>
          <p style={{ margin: '4px 0 0 0', color: '#64748b', fontSize: '0.88rem' }}>
            Gérez la liste complète des experts affichés sur la page /experts avec téléversement direct de photos
          </p>
        </div>

        <button
          onClick={() => {
            resetForm();
            setIsFormOpen(true);
          }}
          style={{
            background: '#1b1e4f',
            color: 'white',
            border: 'none',
            padding: '9px 18px',
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}
        >
          <FiPlus size={16} /> Ajouter un expert
        </button>
      </div>

      {saveSuccess && (
        <div style={{ background: '#d1fae5', border: '1px solid #10b981', color: '#065f46', padding: '10px 16px', borderRadius: 6, marginBottom: 16, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
          <FiCheck size={16} /> Enregistré avec succès ! Vos modifications sont en ligne.
        </div>
      )}

      {/* Form Modal / Panel */}
      {isFormOpen && (
        <div style={{ background: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: 8, padding: 20, marginBottom: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#1e293b' }}>
              {editingId ? "Modifier l'expert" : "Ajouter un nouvel expert"}
            </h3>
            <button onClick={resetForm} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#64748b' }}>
              <FiX size={20} />
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
              {/* Photo Upload */}
              <ImageUploadField
                label="Photo de profil de l'Expert (Upload image)"
                value={formData.image}
                onChange={(url) => setFormData(prev => ({ ...prev, image: url }))}
                helpText="Importez le portrait de l'expert (format carré ou portrait recommandé)"
              />

              {/* Company Logo Upload */}
              <ImageUploadField
                label="Logo de l'Institution / Entreprise (Upload image)"
                value={formData.company_logo}
                onChange={(url) => setFormData(prev => ({ ...prev, company_logo: url }))}
                helpText="Importez le logo de l'institution ou entreprise de l'expert"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Nom complet *</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: Dr. Redouane EL MAJDOULI"
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Titre / Fonction *</label>
                <input
                  type="text"
                  required
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: Expert en Cyber-Intelligence"
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Domaine d'expertise</label>
                <input
                  type="text"
                  value={formData.domain}
                  onChange={(e) => setFormData({ ...formData, domain: e.target.value })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: Cyber-sécurité, Géopolitique"
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Institution / Entreprise</label>
                <input
                  type="text"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: Université Ibn Zohr"
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Pays</label>
                <input
                  type="text"
                  value={formData.country}
                  onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: Maroc, France, USA"
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Code Pays (drapeau, ex: ma, fr, us, gb)</label>
                <input
                  type="text"
                  value={formData.countryCode}
                  onChange={(e) => setFormData({ ...formData, countryCode: e.target.value.toLowerCase() })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: ma"
                  maxLength={2}
                />
              </div>
            </div>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
              <button
                type="button"
                onClick={resetForm}
                style={{ background: '#e2e8f0', color: '#475569', border: 'none', padding: '9px 18px', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
              >
                Annuler
              </button>
              <button
                type="submit"
                style={{ background: '#1b1e4f', color: 'white', border: 'none', padding: '9px 22px', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
              >
                <FiSave size={15} /> {editingId ? 'Enregistrer les modifications' : 'Ajouter cet expert'}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Grid of Experts */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 18 }}>
        {experts.map(expert => (
          <div
            key={expert.id}
            style={{
              border: '1px solid #e2e8f0',
              borderRadius: 8,
              padding: 16,
              background: '#ffffff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.03)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div>
              <div style={{ display: 'flex', gap: 14, alignItems: 'center', marginBottom: 12 }}>
                <div style={{ width: 64, height: 64, borderRadius: '50%', overflow: 'hidden', background: '#f1f5f9', border: '2px solid #cbd5e1', flexShrink: 0 }}>
                  {expert.image ? (
                    <img src={expert.image} alt={expert.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
                      <FiUsers size={24} />
                    </div>
                  )}
                </div>

                <div style={{ minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <h4 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1e293b' }}>{expert.name}</h4>
                    {expert.countryCode && (
                      <img src={`https://flagcdn.com/24x18/${expert.countryCode}.png`} alt={expert.country} style={{ width: 16, height: 12 }} />
                    )}
                  </div>
                  <p style={{ margin: '3px 0 0 0', fontSize: 12, color: '#2563eb', fontWeight: 600 }}>{expert.title}</p>
                  <p style={{ margin: '2px 0 0 0', fontSize: 11, color: '#64748b' }}>{expert.company || expert.country}</p>
                </div>
              </div>

              {expert.domain && (
                <span style={{ fontSize: 11, background: '#f1f5f9', color: '#475569', padding: '2px 8px', borderRadius: 4, display: 'inline-block', marginBottom: 10 }}>
                  {expert.domain}
                </span>
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, borderTop: '1px solid #f1f5f9', paddingTop: 10 }}>
              <button
                onClick={() => handleEdit(expert)}
                style={{ background: '#f1f5f9', color: '#2563eb', border: 'none', padding: '6px 12px', borderRadius: 4, fontSize: 12, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}
              >
                <FiEdit2 size={13} /> Modifier
              </button>
              <button
                onClick={() => handleDelete(expert.id)}
                style={{ background: '#fee2e2', color: '#dc2626', border: 'none', padding: '6px 12px', borderRadius: 4, fontSize: 12, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}
              >
                <FiTrash2 size={13} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
